import { Component } from "@angular/core";
import { CatalogService } from "../../services/catalog.service";
import { Catalog, Page, Element } from "@app/data/catalog";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { Listing } from "@app/data/listing";

import { ItemListing, ListingCartItem } from "shopping/cart";
import { UntypedFormControl } from "@angular/forms";
import * as _ from "underscore";
import { fadeInOutAnimation } from "@app/animations";
import * as tearSheetUtils from "@js/tear-sheet.utils";
import { UserService } from "@app/services/user.service";
import { SupermodalComponent } from "@app/components/common/supermodal.component";
import { ViewChild } from "@angular/core";
import { PipeTransform } from "@angular/core";
import { Pipe } from "@angular/core";
import { debounceTime } from "rxjs";
import { CartService } from "shopping/cart.service";

class Customer {
  public email: String;
  public firstName: String;
  public lastName: String;
  public addressFirstLine: String;
  public addressSecondLine: String;
  public provinceState: String;
  public country: String;
}

@Pipe({
  name: "optimalImage",
})
export class OptimalImagePipe implements PipeTransform {
  transform(image: any): String {
    if (typeof image === "string" || image instanceof String) {
      return image;
    }
    return image.compressed || image.original;
  }
}

@Component({
  templateUrl: "./catalog-order-sheet.view.component.html",
  animations: [fadeInOutAnimation],
})
export class CatalogOrderSheetViewComponent {
  @ViewChild("supermodaHasExpired") supermodalHasExpired: SupermodalComponent;

  showOptionPrices = false;
  keywords: string = "";
  cartSize: number = 0;
  currentListing: ItemListing;
  customer: Customer;
  catalog: Catalog;
  listings: ItemListing[] = [];
  filteredListings: ItemListing[] = [];
  //  categoriesDisplayed: boolean = false;
  keywordsFormControl = new UntypedFormControl();
  categories: string[] = [];
  selectedCategory: string = "";
  displayedImage: string = "";

  constructor(
    private route: ActivatedRoute,
    private catalogService: CatalogService,
    private userService: UserService,
    private cartService: CartService<ListingCartItem>
  ) {
    this.refreshCartSize();
  }

  refreshCartSize() {
    this.cartSize = this.cartService.getItems().length;
  }

  ngAfterViewInit(): void {
    this.cartService.onChange.subscribe((item) => this.refreshCartSize());
    this.catalogService
      .getCatalog(this.route.snapshot.params["id"])
      .then((catalog) => {
        this.catalog = catalog;
        tearSheetUtils.initListingsCategories(catalog);
        this.listings = catalog.listings;
        this.listings.forEach((listing) => {
          listing.quantity = 0;
          listing.variations.forEach((variation) => {
            variation.options.forEach((option) => {
              option.quantity = 0;
            });
          });
        });
        this.categories = catalog.categories;
        this.categories.sort(function (a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        });
        this.filteredListings = _.sortBy(this.listings, "title");
        this.userService.hasExpired(catalog.user._id).then((hasExpired) => {
          if (hasExpired) {
            this.supermodalHasExpired.open();
          }
        });
      });
    this.keywordsFormControl.valueChanges
      .pipe(
        debounceTime(50) // Apply debounceTime using pipe
      )
      .subscribe((newValue) => {
        this.keywords = newValue;
        this.filter();
      });
  }

  filter() {
    this.filteredListings = _.sortBy(
      _.filter(this.listings, (listing) => {
        return (
          (listing.title.toLowerCase().indexOf(this.keywords.toLowerCase()) >
            -1 ||
            listing.description
              .toLowerCase()
              .indexOf(this.keywords.toLowerCase()) > -1) &&
          (this.selectedCategory.length == 0 ||
            listing.category == this.selectedCategory)
        );
      }),
      "title"
    );
  }

  increaseQuantity(option) {
    console.log("option", option);
    option.quantity++;
  }

  viewDetails(listing: ItemListing) {
    this.currentListing = listing;
    this.displayedImage = this.currentListing.main_image;

    this.showOptionPrices = true;
    this.currentListing.variations.forEach((variation) => {
      variation.options.forEach((option) => {
        this.showOptionPrices =
          this.showOptionPrices && option.price !== this.currentListing.price;
      });
    });
    // this.categoriesDisplayed = false;
  }

  switchDisplayedImage(image: string) {
    this.displayedImage = image;
  }

  hideSidePanels() {
    // this.categoriesDisplayed = false;
    this.currentListing = null;
  }

  decreaseQuantity(option) {
    option.quantity--;
  }

  hashCode(value: String) {
    var hash = 0,
      i,
      chr;
    if (value.length === 0) return hash;
    for (i = 0; i < value.length; i++) {
      chr = value.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }

  addToCart(itemListing: ItemListing, quantity, price, variation, option) {
    let id = itemListing.id;
    if (variation && option) {
      if (variation.id) {
        id += `-${variation.id}`;
      } else if (variation.title) {
        id += `-${this.hashCode(variation.title)}`;
      }

      if (option.id) {
        id += `-${option.id}`;
      } else {
        id += `-${this.hashCode(option.title)}`;
      }
    }
    let listingCartItem = new ListingCartItem({
      id,
      itemListing,
      quantity,
      price,
      variation,
      option,
    });
    this.cartService.addItem(listingCartItem);
  }

  emptyCart() {
    this.cartService.clear();
  }

  completeOrder() {}

  selectCategory(category: string) {
    this.selectedCategory = category;
    this.filter();
  }
  moveToHomePage() {
    window.location.href = "/";
  }
}
